<template lang="pug">
div.w-full#id
    highcharts(:options="chartData")
</template>

<!-- props format :-
 data: {
   xAxis: array,
   seriesData: [{name: string, data: array}, ...],
   ylabel: string (optional),
   description: string (optional),
   legend: boolean (optional) 
 }
 topMargin: Number (optional)
 legendYPos: Number (optional)
 hideAxis: boolean (optional)
 height: Number (optional)
 -->

<script>
import Highcharts from 'highcharts';
export default {
    name: 'lineChart',
    props: ['data', 'topMargin', 'legendYPos', 'hideAxis', 'height','id'],
    data() {
        return {
            chartData: {},
            color_codes: [
                "#47A694",
                "#eea39f",
                "#c8beea",
                "#79A69E",
                "#54736D",
                "#265950",
                "#79A69E",
                "#317367",
                "#54736D",
                "#52BFAB",
                "#84B5AC",
                "#5F827C",
                "#388273",
                "#59CFB7",
            ],
        }
    },
    watch: {
        data: {
            handler() {
                this.initiate();
            },
            deep: true
        }
    },
    mounted() {
        this.initiate();
        console.log("check all the data ",this.data)
    },
    methods: {
        chartYLabel() {
            if (this.data.hasOwnProperty('ylabel')) return this.data.ylabel;
            else return this.data.seriesData[0].name;
        },
        chartDescription() {
            if (this.data.hasOwnProperty('description')) return this.data.description;
            else return '';
        },
        chartMarginTop() {
            if (this.topMargin) return this.topMargin;
            else return 60;
        },
        chartYLegend() {
            if (this.legendYPos) return this.legendYPos;
            else return 0;
        },
        plotLegend() {
            if (this.data.legend) {
                return {
                    itemStyle: {
                        fontSize: "0.8vw"
                    },
                    enabled: true,
                    alignColumns: true,
                    align: "right",
                    y: this.chartYLegend(),
                    x: 0,
                    squareSymbol: true,
                    verticalAlign: "top",
                    itemDistance: 35,
                    margin: 0,
                    padding: 0,
                    symbolHeight: 14,
                    symbolWidth: 14,
                    symbolRadius: 4
                }
            } else if (!this.data.legend) {
                return  {
                    enabled: false,
                }
            }
        },
        enableAxis(){
            if(this.hideAxis) return false; 
            else return true
        },
        chartHeight(){
            if(this.height) return this.height;
            else return null
        },

        initiate() {
            let self = this
            if (!this.data.seriesData.length) return;
            const seriesData = [];
            // looping over the seriesData provided such that there could be as many lines as provided.
            this.data.seriesData.forEach((element, idx) => {
                seriesData.push({
                    name: element.name,
                    type: 'line',
                    color: this.color_codes[idx],
                    data: element.data
                })
            });

            Highcharts.setOptions({
                lang: {
                    decimalPoint: '.',
                    thousandsSep: ','
                }
            });
            this.chartData = {
                chart: {
                    marginTop: this.chartMarginTop(),
                    // width: '100vw',
                    height: this.chartHeight(),
                    backgroundColor: 'transparent',  
                },
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: this.chartHeight()
                        },
                        chartOptions: {
                            chart: {
                                height: 300
                            },
                            subtitle: {
                                text: null
                            },
                            navigator: {
                                enabled: false
                            }
                        }
                    }]
                },
                title: {
                    text: '',
                    align: 'center'
                },
                subtitle: {
                    text: this.chartDescription(),
                    align: 'center',
                    y: 40,
                    style: {
                        fontSize: "0.7vw"
                    },
                },
                credits: {
                    enabled: false
                },
                yAxis: {
                    title: {
                        text: this.chartYLabel()
                    },
                    visible: this.enableAxis()
                },
                xAxis: [{
                    categories: this.data.xAxis,
                    crosshair: true,
                    visible: this.enableAxis()
                }],
                legend: this.plotLegend(),
                series: seriesData,
                tooltip: {
                    formatter: function () {
                        if (seriesData.length === 1) {
                            if (self.data.prefix){
                                return this.x + ' : <b>'+ self.data.prefix +' '+ (this.y).toLocaleString("en-US") + '</b>';
                            }

                            if(self.data.sufix){
                                return this.x + ' : <b>'+ (this.y).toLocaleString("en-US") + self.data.sufix +'</b>';
                            }
                            
                            if(!(self.data.prefix && self.data.sufix)){  
                                return this.x + ' : <b>'+  (this.y).toLocaleString("en-US") + '</b>';
                            }
                        } else {
                            let localTooltip = `${this.x} <br/>`;
                            seriesData.forEach((datapoint, index) => {
                                localTooltip += `${datapoint.name} : <b> ${datapoint.data[index].toFixed(2)} </b> <br/> `
                            });
                            return localTooltip;
                        }
                    },
                    shape: 'rect',
                    borderWidth: 0,
                    shadow: {
                        color: "#d6d6d6",
                        opacity: 0.1,
                        width: 10,
                    },
                    borderRadius: 6,
                    backgroundColor: "#ffffff",
                    headerFormat: '',
                    style: {
                        fontSize: '14px'
                    },
                }
            }
        }
    }
}
</script>

<style></style>